import React, { useCallback, useRef } from "react";
import { Card, Typography } from "@mui/material";
import Button from "@mui/material/Button";

const StatusCard = ({ type = "alertCard", status = "open", value, handleStatusCardClick }) => {
  const alertCardStyle = {
    p: "10px 10px 25px 10px",
    marginBottom: "15px"
  };

  const tableAlertsStyles = {
    waxWidth: 93,
    width: 93,
    p: "3px 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textTransform: 'initial',
    cursor: 'pointer'
  };

  const debounceTimeout = useRef(null);

  const debounce = (func, delay) => {
    return (...args) => {
      clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleStatusClick = async () => {
    try {
      // if (status === 'close') {
      //   console.log('not allowed to change close status');
      // } else {
      //   await handleStatusCardClick();
      // }
      await handleStatusCardClick();
    } catch (error) {
      console.error('Error during status card button click', error);
    }
  };

  const debouncedStatusClick = useCallback(debounce(handleStatusClick, 300), [handleStatusCardClick, status]);

  const getCardStyles = () => {
    let res;

    switch (type) {
      case "alertCard":
        res = { ...alertCardStyle };
        break;
      case "tableAlertCard":
        res = { ...tableAlertsStyles };
        break;
    }

    res = {
      ...res,
      boxShadow: "0px 4px 40px 0px rgba(226, 236, 249, 0.60)",
      ".statusCardContainer": {
        display: "flex",
        justifyContent: type === "alertCard" ? "space-between" : "center",
        ".alertCardText": {
          fontWeight: 600,
          fontSize: type === "alertCard" ? "14px" : "12px"
        }
      }
    };

    switch (status) {
      case "open":
        res.backgroundColor = "#E0BFB8";
        res[".statusCardContainer"].color = "#EA0234";
        break;
      case "inProgress":
        res.backgroundColor = "#B6CFF1";
        res[".statusCardContainer"].color = "#4880FF";
        break;
      case "close":
        res.backgroundColor = "#89D8C2";
        res[".statusCardContainer"].color = "#2B9F7F";
        break;
    }

    return res;
  };

  const getStatusCardText = () => {
    switch (status) {
      case "open":
        return 'Open';
      case "inProgress":
        return 'In Progress';
      case "close":
        return 'Close';
    }
  };

  return (
    type === 'alertCard' ? (
      <Card sx={getCardStyles()}>
        <div className="statusCardContainer">
          <Typography className="alertCardText">
            {getStatusCardText()}
          </Typography>
          {
            type === 'alertCard' && (
              <Typography className="alertCardText">
                {value}
              </Typography>
            )
          }
        </div>
      </Card>
    ) : (
      <Button
        sx={getCardStyles()}
        onClick={debouncedStatusClick}
      >
        <div className="statusCardContainer">
          <Typography className="alertCardText">
            {getStatusCardText()}
          </Typography>
          {
            type === 'alertCard' && (
              <Typography className="alertCardText">
                {value}
              </Typography>
            )
          }
        </div>
      </Button>
    )
  );
};

export default StatusCard;
